import ApiBase, { baseUrl } from '.';

export default class TokenAuthApi extends ApiBase {
  constructor(token) {
    super(`${baseUrl}/api/TokenAuth`, token);
  }

  authenticate(data) {
    return this.http.post(`${this.baseUrl}/Authenticate`, data);
  }

  getAvailableTenantsForImpersonation(keyword) {
    return this.authHttp.get(`${this.baseUrl}/GetAvailableTenantsForImpersonation`, {
      params: {
        keyword: keyword
      }
    });
  }

  getAvailableUsersForImpersonation(keyword, tenantId = null) {
    return this.authHttp.get(`${this.baseUrl}/GetAvailableUsersForImpersonation`, {
      params: {
        keyword: keyword,
        tenantId: tenantId
      }
    });
  }

  impersonate(targetUserId, targetTenantId = null) {
    return this.authHttp.post(`${this.baseUrl}/Impersonate`, {
      targetUserId,
      targetTenantId
    });
  }

  unImpersonate() {
    return this.authHttp.post(`${this.baseUrl}/UnImpersonate`, {});
  }
}
